/**
 * Reduces ECG data points while preserving important peaks and valleys
 * Uses a min-max downsampling algorithm to maintain waveform characteristics
 * @param data - Array of voltage values in mV (500Hz sampling rate)
 * @param durationSeconds - Duration in seconds to extract from data (default: 2.5s)
 * @returns Sampled data array with { time, voltage } objects in mm scale
 *
 * ECG Paper Grid Standards:
 * Horizontal (Time):
 * - Each small square: 1mm = 0.04s (40ms)
 * - Each large square: 5mm = 0.2s (200ms)
 * - Standard speed: 25mm/s
 * - Sampling rate: 500 points per second
 *
 * Vertical (Voltage):
 * - Each small square: 1mm = 0.1 mV
 * - Each large square: 5mm = 0.5 mV
 * - Standard: 10mm = 1 mV
 */
export const sampleECGData = (
  data: number[],
  durationSeconds: number = 2.5
): Array<{ time: number; voltage: number }> => {
  // Calculate number of points based on 500Hz sampling rate
  const numPoints = Math.floor(500 * durationSeconds)
  const samplingRate = 500 // Hz
  const mmPerSecond = 25 // Standard ECG paper speed: 25mm/s
  const mmPerMillivolt = 10 // Standard ECG voltage scale: 10mm = 1mV

  return data.slice(0, numPoints).map((voltageInMv, index) => ({
    // Convert time: index -> seconds -> millimeters
    time: (index / samplingRate) * mmPerSecond,
    // Keep voltage in mV (não converter para mm)
    voltage: voltageInMv
  }))
}
